export const menuMessages = {
  en: {
    menu: {
      '首页': 'Home',
      '小区': 'Cmty',
      '物业': 'Property',
      '用户': 'User',
      'OA': 'OA',
      '财务': 'Financial',
      'IOT': 'IOT',
      '市场': 'Market',
      '设置': 'Settings',
      '组织': 'Org',
      '物业管理': 'Property Mgmt',
      '房产': 'Room',
      '办公': 'OA',
      '采购': 'Purchase',
      'DEMO管理': 'Demo',
      '服务': 'Service',
      '配置': 'Config',
      '缓存': 'Cache',
      '菜单': 'Menu',
      '任务': 'Task',
      '系统': 'System',
      '报修': 'Repair',
      '费用': 'Fee',
      '设备': 'Device',
      '停车': 'Parking',
      '巡检': 'Inspect',
      '订单': 'Order',
      '运营': 'Operation',
      '标签': 'Tag',
      '文档': 'Doc',
      '属性': 'Attribute',
      '租赁': 'Lease',
      '合同': 'Contract',
      '营销': 'Marketing',
      '报表': 'Report',
      '日志': 'Log',
      '物业手机版': 'Mobile',
      '会员': 'Member',
      '统计': 'Statistics',
      '手机': 'Mobile',
      '店铺': 'Store',
      '集采': 'Bulk Purchase',
      '供应商': 'Supplier',
      '优惠': 'Discount',
      '活动': 'Activity',
      '手机报表': 'Mobile Report',
      '手机停车': 'Mobile Parking',
      '手机工单': 'Mobile Work Order',
      '手机核销': 'Mobile Verify',
      '台账': 'Ledger',
      '巡楼': 'Patrol',
      '资产': 'Asset',
      '工单': 'Work Order',
      '员工信息': 'Staff Info',
      '房屋管理': 'Room Mgmt',
      '我的小区': 'My Community',
      '发布公告': 'Publish Notice',
      '业主信息': 'Owner Info',
      '业主成员': 'Owner Member',
      '车位信息': 'Parking Info',
      '采购申请': 'Purchase Request',
      'DEMO用例': 'Demo Case',
      '小区信息': 'Community Info',
      '应用信息': 'App Info',
      '服务信息': 'Service Info',
      '服务实现': 'Service Impl',
      '配置中心': 'Config Center',
      '服务注册': 'Service Registry',
      '访客登记': 'Visitor Registration',
      '刷新缓存': 'Refresh Cache',
      '菜单组': 'Menu Group',
      '菜单维护': 'Menu Maint',
      '服务提供': 'Service Provider',
      '定时任务': 'Scheduled Task',
      '审核小区': 'Audit Community',
      '商户审核': 'Audit Merchant',
      '资产导入导出': 'Asset Import/Export',
      '组织信息': 'Org Info',
      '报修待办': 'Repair Todo',
      '报修已办': 'Repair Done',
      '物品信息': 'Item Info',
      '物品领用': 'Item Requisition',
      '投诉建议': 'Complaint',
      '设备台账': 'Device Ledger',
      '物联网同步': 'IOT Sync',
      '开门记录': 'Access Log',
      '业主认证': 'Owner Auth',
      '信息发布': 'Info Publish',
      '停车场管理': 'Parking Mgmt',
      '在场车辆': 'In Vehicle',
      '进场记录': 'Entry Log',
      '剩余车位': 'Remaining Slot',
      '费用项设置': 'Fee Item Setting',
      '车辆收费': 'Vehicle Fee',
      '房屋收费': 'Room Fee',
      '修改密码': 'Change Pwd',
      '巡检点': 'Inspect Point',
      '巡检路线': 'Inspect Route',
      '巡检计划': 'Inspect Plan',
      '商户信息': 'Merchant Info',
      '审核入驻小区': 'Audit Merchant Community',
      '巡检任务': 'Inspect Task',
      '受理单': 'Acceptance Form',
      '发布需求': 'Publish Demand',
      '旧货甩卖': 'Secondhand Sale',
      '退费审核': 'Refund Audit',
      '小程序配置': 'Mini Program Config',
      '欠费催缴': 'Arrears Collection',
      '设备位置': 'Device Location',
      '流程管理': 'Process Mgmt',
      '公众号': 'WeChat Official',
      '报修设置': 'Repair Setting',
      '电话报修': 'Phone Repair',
      '工单池': 'Work Order Pool',
      '小区大屏': 'Community Screen',
      '费用导入': 'Fee Import',
      '租赁配置': 'Lease Config',
      '房源信息': 'Property Info',
      '出租审核': 'Rent Audit',
      '业主车辆': 'Owner Vehicle',
      '水电抄表': 'Meter Reading',
      '房源': 'Property Source',
      '楼栋公摊': 'Building Share',
      '租赁预约': 'Lease Booking',
      '合同信息': 'Contract Info',
      '合同查询': 'Contract Query',
      '合同类型': 'Contract Type',
      '登录日志': 'Login Log',
      '打印配置': 'Print Config',
      '补打收据': 'Reprint Receipt',
      '出租历史': 'Rent History',
      '信息大类': 'Info Category',
      '文档信息': 'Document Info',
      '业务受理': 'Business Accept',
      '费用汇总表': 'Fee Summary',
      '费用明细表': 'Fee Detail',
      '欠费明细表': 'Arrears Detail',
      '缴费明细表': 'Payment Detail',
      '商城订单': 'Mall Order',
      '交互日志': 'Operation Log',
      '退货订单': 'Return Order',
      '折扣设置': 'Discount Setting',
      'Databus': 'Databus',
      '员工认证': 'Staff Auth',
      '优惠申请': 'Discount Apply',
      '商户管理员': 'Merchant Admin',
      '商铺管理': 'Shop Mgmt',
      '考勤班组': 'Attendance Group',
      '收银台': 'Cashier',
      '投诉待办': 'Complaint Todo',
      '房产查询': 'Property Query',
      '空置房': 'Vacant Room',
      '维修工单': 'Repair Work Order',
      '公告': 'Notice',
      '维修待办': 'Repair Todo',
      '巡检打卡': 'Inspect Checkin',
      '房屋装修': 'Room Renovation',
      '报修汇总表': 'Repair Summary',
      '今日考勤': 'Today Attendance',
      '月考勤': 'Monthly Attendance',
      '考勤记录': 'Attendance Record',
      '问卷调研': 'Survey',
      '问卷题目': 'Survey Question',
      '店铺小区': 'Store Community',
      '收款账户': 'Payment Account',
      '财务明细': 'Financial Detail',
      '保证金': 'Deposit',
      '商品管理': 'Product Mgmt',
      '订单信息': 'Order Info',
      '店铺信息': 'Store Info',
      '商品规格': 'Product Spec',
      '商品分组': 'Product Group',
      '合同变更': 'Contract Change',
      '到期合同': 'Expiring Contract',
      '起草合同': 'Draft Contract',
      '报修回访': 'Repair Return Visit',
      '强制回单': 'Force Return',
      '仓库信息': 'Warehouse Info',
      '调拨申请': 'Transfer Request',
      '我的物品': 'My Item',
      '代客报修': 'Proxy Repair',
      '自助缴费': 'Self Payment',
      '小区店铺': 'Community Store',
      '会员信息': 'Member Info',
      '合同甲方': 'Contract Party A',
      '出入库明细': 'Stock Detail',
      '合同收费': 'Contract Fee',
      '转赠记录': 'Transfer Record',
      '使用记录': 'Usage Record',
      '会员等级': 'Member Level',
      '未收费房屋': 'Uncharged Room',
      '金币购买记录': 'Coin Purchase Record',
      '调拨明细': 'Transfer Detail',
      '物品规格': 'Item Spec',
      '商品评论': 'Product Review',
      '店铺访问': 'Store Visit',
      '退货地址': 'Return Address',
      '发布广告': 'Publish Ad',
      '物品调拨': 'Item Transfer',
      '便民信息维护': 'Convenience Info',
      '便民菜单维护': 'Convenience Menu',
      '服务类型': 'Service Type',
      '物品类型': 'Item Type',
      '调拨审批': 'Transfer Approve',
      '采购审批': 'Purchase Approve',
      '领用审批': 'Requisition Approve',
      '服务管理': 'Service Mgmt',
      '客户催单': 'Customer Urge',
      '服务评价': 'Service Review',
      '费用大类': 'Fee Category',
      '费用标准': 'Fee Standard',
      '手机商城菜单': 'Mobile Mall Menu',
      '巡检明细': 'Inspect Detail',
      '提现记录': 'Withdraw Record',
      '服务支付': 'Service Payment',
      '服务已办': 'Service Done',
      '提现审核': 'Withdraw Approve',
      '服务工单池': 'Service Work Order Pool',
      '订单费用': 'Order Fee',
      '账户提现': 'Account Withdraw',
      '服务待办': 'Service Todo',
      '开户行管理': 'Bank Mgmt',
      '业主账户': 'Owner Account',
      '提现付款': 'Withdraw Payment',
      '店铺类型': 'Store Type',
      '经营范围': 'Business Scope',
      '设置保证金': 'Set Deposit',
      '上架服务': 'List Service',
      '保证金明细': 'Deposit Detail',
      '上架商品': 'List Product',
      '资产盘点': 'Asset Check',
      '进货退货': 'Purchase Return',
      '进货单': 'Purchase Order',
      '出库单': 'Stock Out',
      '入库单': 'Stock In',
      '仓库调拨': 'Warehouse Transfer',
      '库存查询': 'Stock Query',
      '库存警告': 'Stock Alert',
      '仓库管理': 'Warehouse Mgmt',
      '进货统计': 'Purchase Statistics',
      '支付配置': 'Payment Config',
      '销售排行': 'Sales Ranking',
      '进货明细': 'Purchase Detail',
      '销售明细': 'Sales Detail',
      '押金报表': 'Deposit Report',
      '销售成本表': 'Sales Cost',
      '销售成本明细': 'Sales Cost Detail',
      '商品导入': 'Product Import',
      '商品标签': 'Product Tag',
      '首页菜单': 'Home Menu',
      '首页通知': 'Home Notice',
      '首页广告': 'Home Ad',
      '打标商品': 'Tagged Product',
      '初始化小区': 'Init Community',
      '返省上报': 'Province Report',
      '疫情设置': 'Pandemic Setting',
      '疫情上报': 'Pandemic Report',
      '欠费分析': 'Arrears Analysis',
      '流程实例': 'Process Instance',
      '我的流程': 'My Process',
      '小区配置': 'Community Config',
      '工作办理': 'Work Handle',
      'OA流程': 'OA Process',
      '业务轨迹': 'Business Track',
      '收据模板': 'Receipt Template',
      '取消费用': 'Cancel Fee',
      '产权登记': 'Property Registration',
      '设备类型': 'Device Type',
      '视频监控': 'Video Monitor',
      '岗亭管理': 'Booth Mgmt',
      '车位申请': 'Parking Application',
      '报表组': 'Report Group',
      '报表组件': 'Report Component',
      '报修报表': 'Repair Report',
      '报表信息': 'Report Info',
      '购买记录': 'Purchase Record',
      '制作优惠券': 'Create Coupon',
      '优惠劵管理': 'Coupon Mgmt',
      '店铺变更': 'Store Change',
      '变更记录': 'Change Record',
      '店铺配置': 'Store Config',
      '赠送记录': 'Gift Record',
      '菜单目录': 'Menu Directory',
      '营业报表': 'Business Report',
      '周边商家': 'Nearby Merchant',
      '物业公司': 'Property Company',
      '结构图': 'Structure Chart',
      '巡检项目': 'Inspect Item',
      '车位结构图': 'Parking Structure',
      '巡检报表': 'Inspect Report',
      '供应链': 'Supply Chain',
      '集采中心': 'Bulk Center',
      '集采订单': 'Bulk Order',
      '商品定价': 'Product Pricing',
      '字典': 'Dictionary',
      '角色权限': 'Role Permission',
      '运营员工': 'Operation Staff',
      '业主反馈': 'Owner Feedback',
      '系统配置': 'System Config',
      '数据权限': 'Data Permission',
      '员工考勤': 'Staff Attendance',
      '盘点管理': 'Check Mgmt',
      '场地管理': 'Venue Mgmt',
      '场地预约订单': 'Venue Booking Order',
      '场地预约': 'Venue Booking',
      '下载中心': 'Download Center',
      '营销配置': 'Marketing Config',
      '营销方式': 'Marketing Method',
      '营销规则': 'Marketing Rule',
      '营销记录': 'Marketing Record',
      '营销黑名单': 'Marketing Blacklist',
      '排班设置': 'Schedule Setting',
      '排班表': 'Schedule',
      '班次设置': 'Shift Setting',
      '检查项': 'Check Item',
      '保养标准': 'Maintenance Standard',
      '场地核销': 'Venue Verify',
      '保养计划': 'Maintenance Plan',
      '保养明细': 'Maintenance Detail',
      '保养任务': 'Maintenance Task',
      '保养设备': 'Maintenance Device',
      '供应商类型': 'Supplier Type',
      '巡检报告': 'Inspect Report',
      '优惠券订单': 'Coupon Order',
      '优惠券': 'Coupon',
      '优惠券市场': 'Coupon Market',
      '业主优惠券': 'Owner Coupon',
      '优惠券使用': 'Coupon Use',
      '赠送规则': 'Gift Rule',
      '核销优惠券': 'Verify Coupon',
      '订单核销': 'Order Verify',
      '积分标准': 'Point Standard',
      '积分赠送': 'Point Gift',
      '小区积分': 'Community Point',
      '积分规则': 'Point Rule',
      '核销积分': 'Verify Point',
      '积分设置': 'Point Setting',
      '拼团商品': 'Group Buy Product',
      '拼团订单': 'Group Buy Order',
      '拼团退单': 'Group Buy Return',
      '秒杀商品': 'Seckill Product',
      '注册协议': 'Register Agreement',
      '放行类型': 'Release Type',
      '物品放行': 'Item Release',
      '访客审核': 'Visitor Audit',
      '配置项': 'Config Item',
      '云打印机': 'Cloud Printer',
      '云打印规则': 'Cloud Print Rule',
      '考勤人员': 'Attendance Staff',
      '小区公示': 'Community Notice',
      '数据统计': 'Data Statistics',
      '导入日志': 'Import Log',
      '业主投票': 'Owner Vote',
      '操作日志': 'Operation Log',
      '调用三方': 'Call Third Party',
      '审批配置': 'Approve Config',
      '支付二维码': 'Payment QR',
      '房屋费用明细': 'Room Fee Detail',
      '充电桩订单': 'Charger Order',
      '催缴登记': 'Collection Register',
      '业主': 'Owner',
      '道闸': 'Barrier',
      '发票': 'Invoice',
      '发票抬头': 'Invoice Title',
      '运营分析': 'Operation Analysis',
      '小区费用汇总': 'Community Fee Summary',
      '工作单类型': 'Work Order Type',
      '起工作单': 'Create Work Order',
      '员工巡楼': 'Staff Patrol',
      '办工作单': 'Handle Work Order',
      '抄送我的': 'CC Me',
      '临时车缴费': 'Temp Vehicle Payment',
      '投诉类型': 'Complaint Type',
      '小区金币': 'Community Coin',
      '监控': 'Monitor',
      '充电桩': 'Charger',
      '用户积分': 'User Point',
      '积分交易': 'Point Transaction',
      '工作单扣款': 'Work Order Deduction',
      '小区房屋': 'Community Room',
      '小区业主': 'Community Owner',
      '小区费用项': 'Community Fee Item',
      '小区车辆': 'Community Vehicle',
      '小区报修': 'Community Repair',
      '房屋费用': 'Room Fee',
      '小区巡检计划': 'Community Inspect Plan',
      '物业用户': 'Property User',
      '小区投诉': 'Community Complaint',
      '缴费记录': 'Payment Record',
      '小区工作单': 'Community Work Order',
      '小区欠费': 'Community Arrears',
      '地区': 'Area',
      '物业员工': 'Property Staff',
      '小区公众号': 'Community WeChat',
      '小区小程序': 'Community Mini Program',
      '小区支付': 'Community Payment',
      '充电订单': 'Charge Order',
      '小区门禁': 'Community Access',
      '水电充值': 'Utility Recharge',
      '门禁出入': 'Access In/Out',
      '车辆出入': 'Vehicle In/Out',
      '水电表': 'Utility Meter',
      '道闸相机': 'Barrier Camera',
      '员工小区': 'Staff Community',
      '公摊抄表': 'Share Meter Reading',
      '商铺收费': 'Shop Fee',
      '物联网': 'IOT',
      '商城': 'Mall',
      '常用菜单': 'Common Menu',
      '搜索': 'Search',
      '查询我的小区': 'Query My Community',
      '费用套餐': 'Fee Package',
      '临时缴费': 'Temp Payment',
      '按量缴费': 'Pay by Usage',
      '创建费用': 'Create Fee ',
      '装修审核': 'Renovation Audit',
      '房屋产权登记审批权限': 'Property Registration Approve',
      '删除房屋': 'Delete Room',
      '添加房屋': 'Add Room',
      '修改房屋': 'Edit Room',
      '退房': 'Checkout',
      '交房': 'Hand over',
      '删除业主': 'Delete Owner',
      '添加业主': 'Add Owner',
      '修改业主': 'Edit Owner',
      '绑定业主': 'Bind Owner',
      '预存' : 'Prestore',
      '撤回预存': 'Withdraw Prestore',
      '场地统计': 'Venue Statistics',
      '缴费': 'Payment',
      '费用变更': 'Fee Change',
      '业主脱敏': 'Owner Masking',
      '暂停费用': 'Pause Fee',
      '修改费用项': 'Edit Fee Item',
      '添加费用项': 'Add Fee Item',
      '删除费用项': 'Delete Fee Item',
      '账单催缴': 'Bill Collection',
      '公摊公式': 'Share Formula',
      '空置房验房': 'Vacant Room Check',
      '空置房审核': 'Vacant Room Audit',
      '公摊审核': 'Share Audit',
      '工作单池': 'Work Order Pool',
      '智慧考勤': 'Smart Attendance',
      '查看流程工单': 'View Process Work Order',
      '流程办理': 'Process Handling',
      '工单类型': 'Work Order Type',
      '修改停车场': 'Edit Parking',
      '添加停车场': 'Add Parking',
      '删除停车场': 'Delete Parking',
      '控制台': 'Console',
      '修改车辆': 'Edit Vehicle',
      '添加车辆': 'Add Vehicle',
      '删除车辆': 'Delete Vehicle',
      '释放车位': 'Release Parking',
      '物业费': 'Property Fee',
      '停车费': 'Parking Fee',
      '我的报表': 'My Report',
      '楼栋信息': 'Building Info',
      '单元信息': 'Unit Info',
      '业主详情': 'Owner Detail',
      '车位出租': 'Parking Rent',
      '车位出售': 'Parking Sale',
      '查询小区': 'Query Community',
      '编码映射': 'Code Mapping',
      '服务绑定': 'Service Binding',
      '开发服务': 'Dev Service',
      '公告详情': 'Notice Detail',
      '查看文件权限': 'View File Privilege',
      '上传文件权限': 'Upload File Privilege',
      '添加访客': 'Add Visitor',
      '报修派单': 'Repair Dispatch',
      '审核人员': 'Audit Staff',
      '电话投诉': 'Phone Complaint',
      '投诉已办': 'Complaint Done',
      '设备数据同步': 'Device Data Sync',
      '停车费用': 'Parking Fee',
      '流程设置': 'Process Setting',
      '公众号菜单': 'WeChat Menu',
      '报修师傅': 'Repair Master',
      '报修工单详情': 'Repair Order Detail',
      '微信模板': 'WeChat Template',
      '我爱学习': 'I Love Study',
      '权限测试': 'Privilege Test',
      '欠费缴费': 'Arrears Payment',
      '属性值': 'Attribute Value',
      '添加楼栋': 'Add Building',
      '修改单元': 'Edit Unit',
      '删除楼栋': 'Delete Building',
      '修改楼栋': 'Edit Building',
      '删除单元': 'Delete Unit',
      '添加单元': 'Add Unit',
      '预存费用': 'Prestore Fee',
      '合同类型规格': 'Contract Type Spec',
      '合同审核': 'Contract Audit',
      '托收信息': 'Collection Info',
      '托收明细': 'Collection Detail',
      '租赁详情': 'Lease Detail',
      '商品分类': 'Product Category',
      '费用分项表': 'Fee Sub Table',
      '楼栋费用表': 'Building Fee Table',
      '费用到期提醒': 'Fee Expire Reminder',
      '拼团设置': 'Group Buy Setting',
      '拼团产品': 'Group Buy Product',
      '拼团批次': 'Group Buy Batch',
      '推荐商品': 'Recommended Product',
      '商品订单详情': 'Product Order Detail',
      '费用项折扣': 'Fee Item Discount',
      '微信缴费通知': 'WeChat Payment Notice',
      '物业管理员': 'Property Admin',
      '空置房验房通知': 'Vacant Room Check Notice',
      '空置房审核通知': 'Vacant Room Audit Notice',
      '报修登记通知': 'Repair Register Notice',
      '临时车收费标准': 'Temp Vehicle Fee Standard',
      '删除报修记录': 'Delete Repair Record',
      '修改报修记录': 'Edit Repair Record',
      '报修抢单': 'Repair Grab Order',
      '问卷信息': 'Survey Info',
      '问卷答题': 'Survey Answer',
      '员工考核': 'Staff Assessment',
      '我的问卷': 'My Survey',
      '最美员工': 'Best Staff',
      '房屋装修验收通知': 'Room Renovation Notice',
      '装修记录': 'Renovation Record',
      '子母车辆': 'Parent Child Vehicle',
      '装修详情': 'Renovation Detail',
      '商品目录': 'Product Catalog',
      '专区商品': 'Zone Product',
      '查看所有采购申请': 'View All Purchase Request',
      '查看集团仓库权限': 'View Group Warehouse Privilege',
      '查看所有报修已办权限': 'View All Repair Done Privilege',
      '查看所有物品领用': 'View All Item Requisition',
      '入驻小区审核': 'Join Community Audit',
      '查看所有集团物品信息': 'View All Group Item Info',
      '查看所有报修待办': 'View All Repair Todo',
      '查看所有调拨记录': 'View All Transfer Record',
      '出入库操作': 'Stock Operation',
      '物品供应商': 'Item Supplier',
      '合同费用': 'Contract Fee',
      '物品使用记录': 'Item Usage Record',
      '金币设置': 'Coin Setting',
      '购买金币': 'Buy Coin',
      '商品入库': 'Product Stock In',
      '会员账户': 'Member Account',
      '订单详情': 'Order Detail',
      '查看所有出入库明细': 'View All Stock Detail',
      '查看所有组织架构信息': 'View All Org Info',
      '家政服务': 'Housekeeping Service',
      '家政支付': 'Housekeeping Payment',
      '家政已办': 'Housekeeping Done',
      '家政待办': 'Housekeeping Todo',
      '家政工单池': 'Housekeeping Work Order Pool',
      '家政物品信息': 'Housekeeping Item Info',
      '家政服务评价': 'Housekeeping Review',
      '积分商品': 'Point Product',
      '查看所有人物品': 'View All Person Item',
      '紧急采购': 'Urgent Purchase',
      '出入库统计': 'Stock Statistics',
      '销售统计': 'Sales Statistics',
      '首页推荐': 'Home Recommend',
      '华宁物业报表': 'Huaning Property Report',
      '验房记录': 'Room Check Record',
      '验房记录详情': 'Room Check Record Detail',
      '项目管理': 'Project Management',
      '大厦楼栋': 'Building',
      '问候语设置': 'Greeting Setting',
      '产权登记详情': 'Property Reg Detail',
      '预约车审核权限': 'Book Vehicle Audit Privilege',
      '测试菜单': 'Test Menu',
      '供应链配置': 'Supply Chain Config',
      '供应链供应商分类': 'Supply Chain Supplier Category',
      '门禁设备': 'Access Control Device',
      '考勤机': 'Attendance Machine',
      '车辆道闸': 'Vehicle Barrier',
      '监控设备': 'Monitor Device',
      '服务记录': 'Service Record',
      '修改物品信息': 'Edit Item Info',
      '添加物品信息': 'Add Item Info',
      '删除物品信息': 'Delete Item Info',
      '导入物品信息': 'Import Item Info',
      '查看不对外仓库权限': 'View Internal Warehouse Privilege',
      '删除岗亭': 'Delete Booth',
      '修改岗亭': 'Edit Booth',
      '共享岗亭': 'Share Booth',
      '停车券': 'Parking Coupon',
      '小区商家': 'Community Merchant',
      '优惠券购买订单': 'Coupon Purchase Order',
      '车辆停车劵': 'Vehicle Parking Coupon',
      '停车劵核销': 'Parking Coupon Verify',
      '修改员工': 'Edit Staff',
      '工作单流转': 'Work Order Flow',
      '物业费台账': 'Property Fee Ledger',
      '停车费台账': 'Parking Fee Ledger',
      '查看所有使用记录权限': 'View All Usage Record Privilege',
      '已删除数据': 'Deleted Data',
      '添加databus': 'Add Databus',
      '添加业务轨迹': 'Add Business Track',
      '修改databus': 'Edit Databus',
      '启动定时任务': 'Start Scheduled Task',
      '添加属性': 'Add Attribute',
      '修改菜单目录': 'Edit Menu Directory',
      '删除属性值': 'Delete Attribute Value',
      '添加菜单目录': 'Add Menu Directory',
      '修改配置项': 'Edit Config Item',
      '删除应用': 'Delete App',
      '添加配置项': 'Add Config Item',
      '添加定时任务': 'Add Scheduled Task',
      '修改注册协议': 'Edit Register Agreement',
      '删除业务轨迹': 'Delete Business Track',
      '删除属性': 'Delete Attribute',
      '停止定时任务': 'Stop Scheduled Task',
      '删除databus': 'Delete Databus',
      '修改属性值': 'Edit Attribute Value',
      '添加属性值': 'Add Attribute Value',
      '测试定时任务': 'Test Scheduled Task',
      '添加应用': 'Add App',
      '修改应用': 'Edit App',
      '删除配置项': 'Delete Config Item',
      '修改系统配置': 'Edit System Config',
      '删除字典': 'Delete Dictionary',
      '删除菜单目录': 'Delete Menu Directory',
      '删除定时任务': 'Delete Scheduled Task',
      '修改定时任务': 'Edit Scheduled Task',
      '修改属性': 'Edit Attribute',
      '修改字典': 'Edit Dictionary',
      '添加字典': 'Add Dictionary',
      '修改业务轨迹': 'Edit Business Track',
      '查询服务权限': 'Query Service Privilege',
      '删除菜单组': 'Delete Menu Group',
      '查询菜单列表': 'Query Menu List',
      '新增服务提供': 'Add Service Provider',
      '保存报表组件': 'Save Report Component',
      '删除编码映射': 'Delete Code Mapping',
      '修改手机菜单权限': 'Edit Mobile Menu Privilege',
      '修改服务提供': 'Edit Service Provider',
      '删除报表组件': 'Delete Report Component',
      '修改菜单维护': 'Edit Menu Maint',
      '查询菜单组': 'Query Menu Group',
      '新增编码映射': 'Add Code Mapping',
      '查询服务注册': 'Query Service Registry',
      '缓存查询': 'Cache Query',
      '删除报表组': 'Delete Report Group',
      '查询服务实现': 'Query Service Impl',
      '修改报表组件': 'Edit Report Component',
      '添加服务注册': 'Add Service Registry',
      '删除服务实现': 'Delete Service Impl',
      '保存报表信息': 'Save Report Info',
      '保存手机菜单': 'Save Mobile Menu',
      '删除服务提供': 'Delete Service Provider',
      '查询编码映射': 'Query Code Mapping',
      '修改服务': 'Edit Service',
      '修改编码映射': 'Edit Code Mapping',
      '修改服务实现': 'Edit Service Impl',
      '新增服务实现': 'Add Service Impl',
      '保存报表组': 'Save Report Group',
      '删除服务注册': 'Delete Service Registry',
      '删除服务': 'Delete Service',
      '删除菜单权限': 'Delete Menu Privilege',
      '新增菜单组': 'Add Menu Group',
      '新增菜单权限': 'Add Menu Privilege',
      '修改报表信息': 'Edit Report Info',
      '删除手机菜单权限': 'Delete Mobile Menu Privilege',
      '查询服务提供': 'Query Service Provider',
      '添加服务': 'Add Service',
      '修改报表组': 'Edit Report Group',
      '删除报表信息': 'Delete Report Info',
      '删除仓库权限': 'Delete Warehouse Privilege',
      '调拨入库': 'Transfer Stock In',
      '删除巡检任务': 'Delete Inspect Task',
      '取消采购': 'Cancel Purchase',
      '打印规则': 'Print Rule',
      '业主入驻': 'Owner Settle',
      '智能水电表': 'Smart Meter',
      '充电规则': 'Charge Rule',
      '充电月卡': 'Charge Monthly Card',
      '短信配置': 'SMS Config',
      '基础权限': 'Base Privilege',
      '访客登记查询': 'Visitor Registration Query',
      '个人信息': 'Personal Info',
      '装修验收': 'Renovation Accept',
      '售后订单': 'After Sale Order',
      '待处理订单': 'Pending Order',
      '员工权限': 'Staff Privilege',
      '调拨记录': 'Transfer Record',
      '修改仓库权限': 'Edit Warehouse Privilege',
      '巡检统计推送管理员': 'Inspect Statistics Push Admin',
      '物品供应商删除权限': 'Item Supplier Delete Privilege',
      '物品规格修改权限': 'Item Spec Edit Privilege',
      '物品规格删除权限': 'Item Spec Delete Privilege',
      '导入日志详情': 'Import Log Detail',
      '店铺详情': 'Store Detail',
      '商城运营': 'Mall Operation',
      '数据': 'Data'
      
    }
  },
  zh: {
    menu: {
      '首页': '首页',
      '小区': '小区',
      '物业': '物业',
      '用户': '用户',
      'OA': 'OA',
      '财务': '财务',
      'IOT': 'IOT',
      '市场': '市场',
      '设置': '设置',
      '组织': '组织',
      '物业管理': '物业管理',
      '房产': '房产',
      '办公': '办公',
      '采购': '采购',
      'DEMO管理': 'DEMO管理',
      '服务': '服务',
      '配置': '配置',
      '缓存': '缓存',
      '菜单': '菜单',
      '任务': '任务',
      '系统': '系统',
      '报修': '报修',
      '费用': '费用',
      '设备': '设备',
      '停车': '停车',
      '巡检': '巡检',
      '订单': '订单',
      '运营': '运营',
      '标签': '标签',
      '文档': '文档',
      '属性': '属性',
      '租赁': '租赁',
      '合同': '合同',
      '营销': '营销',
      '报表': '报表',
      '日志': '日志',
      '物业手机版': '物业手机版',
      '会员': '会员',
      '统计': '统计',
      '手机': '手机',
      '店铺': '店铺',
      '集采': '集采',
      '供应商': '供应商',
      '优惠': '优惠',
      '活动': '活动',
      '手机报表': '手机报表',
      '手机停车': '手机停车',
      '手机工单': '手机工单',
      '手机核销': '手机核销',
      '台账': '台账',
      '巡楼': '巡楼',
      '资产': '资产',
      '工单': '工单',
      '员工信息': '员工信息',
      '房屋管理': '房屋管理',
      '我的小区': '我的小区',
      '发布公告': '发布公告',
      '业主信息': '业主信息',
      '业主成员': '业主成员',
      '车位信息': '车位信息',
      '采购申请': '采购申请',
      'DEMO用例': 'DEMO用例',
      '小区信息': '小区信息',
      '应用信息': '应用信息',
      '服务信息': '服务信息',
      '服务实现': '服务实现',
      '配置中心': '配置中心',
      '服务注册': '服务注册',
      '访客登记': '访客登记',
      '刷新缓存': '刷新缓存',
      '菜单组': '菜单组',
      '菜单维护': '菜单维护',
      '服务提供': '服务提供',
      '定时任务': '定时任务',
      '审核小区': '审核小区',
      '商户审核': '商户审核',
      '资产导入导出': '资产导入导出',
      '组织信息': '组织信息',
      '报修待办': '报修待办',
      '报修已办': '报修已办',
      '物品信息': '物品信息',
      '物品领用': '物品领用',
      '投诉建议': '投诉建议',
      '设备台账': '设备台账',
      '物联网同步': '物联网同步',
      '开门记录': '开门记录',
      '业主认证': '业主认证',
      '信息发布': '信息发布',
      '停车场管理': '停车场管理',
      '在场车辆': '在场车辆',
      '进场记录': '进场记录',
      '剩余车位': '剩余车位',
      '费用项设置': '费用项设置',
      '车辆收费': '车辆收费',
      '房屋收费': '房屋收费',
      '修改密码': '修改密码',
      '巡检点': '巡检点',
      '巡检路线': '巡检路线',
      '巡检计划': '巡检计划',
      '商户信息': '商户信息',
      '审核入驻小区': '审核入驻小区',
      '巡检任务': '巡检任务',
      '受理单': '受理单',
      '发布需求': '发布需求',
      '旧货甩卖': '旧货甩卖',
      '退费审核': '退费审核',
      '小程序配置': '小程序配置',
      '欠费催缴': '欠费催缴',
      '设备位置': '设备位置',
      '流程管理': '流程管理',
      '公众号': '公众号',
      '报修设置': '报修设置',
      '电话报修': '电话报修',
      '工单池': '工单池',
      '小区大屏': '小区大屏',
      '费用导入': '费用导入',
      '租赁配置': '租赁配置',
      '房源信息': '房源信息',
      '出租审核': '出租审核',
      '业主车辆': '业主车辆',
      '水电抄表': '水电抄表',
      '房源': '房源',
      '楼栋公摊': '楼栋公摊',
      '租赁预约': '租赁预约',
      '合同信息': '合同信息',
      '合同查询': '合同查询',
      '合同类型': '合同类型',
      '登录日志': '登录日志',
      '打印配置': '打印配置',
      '补打收据': '补打收据',
      '出租历史': '出租历史',
      '信息大类': '信息大类',
      '文档信息': '文档信息',
      '业务受理': '业务受理',
      '费用汇总表': '费用汇总表',
      '费用明细表': '费用明细表',
      '欠费明细表': '欠费明细表',
      '缴费明细表': '缴费明细表',
      '商城订单': '商城订单',
      '交互日志': '交互日志',
      '退货订单': '退货订单',
      '折扣设置': '折扣设置',
      'Databus': 'Databus',
      '员工认证': '员工认证',
      '优惠申请': '优惠申请',
      '商户管理员': '商户管理员',
      '商铺管理': '商铺管理',
      '考勤班组': '考勤班组',
      '收银台': '收银台',
      '投诉待办': '投诉待办',
      '房产查询': '房产查询',
      '空置房': '空置房',
      '维修工单': '维修工单',
      '公告': '公告',
      '维修待办': '维修待办',
      '巡检打卡': '巡检打卡',
      '房屋装修': '房屋装修',
      '报修汇总表': '报修汇总表',
      '今日考勤': '今日考勤',
      '月考勤': '月考勤',
      '考勤记录': '考勤记录',
      '问卷调研': '问卷调研',
      '问卷题目': '问卷题目',
      '店铺小区': '店铺小区',
      '收款账户': '收款账户',
      '财务明细': '财务明细',
      '保证金': '保证金',
      '商品管理': '商品管理',
      '订单信息': '订单信息',
      '店铺信息': '店铺信息',
      '商品规格': '商品规格',
      '商品分组': '商品分组',
      '合同变更': '合同变更',
      '到期合同': '到期合同',
      '起草合同': '起草合同',
      '报修回访': '报修回访',
      '强制回单': '强制回单',
      '仓库信息': '仓库信息',
      '调拨申请': '调拨申请',
      '我的物品': '我的物品',
      '代客报修': '代客报修',
      '自助缴费': '自助缴费',
      '小区店铺': '小区店铺',
      '会员信息': '会员信息',
      '合同甲方': '合同甲方',
      '出入库明细': '出入库明细',
      '合同收费': '合同收费',
      '转赠记录': '转赠记录',
      '使用记录': '使用记录',
      '会员等级': '会员等级',
      '未收费房屋': '未收费房屋',
      '金币购买记录': '金币购买记录',
      '调拨明细': '调拨明细',
      '物品规格': '物品规格',
      '商品评论': '商品评论',
      '店铺访问': '店铺访问',
      '退货地址': '退货地址',
      '发布广告': '发布广告',
      '物品调拨': '物品调拨',
      '便民信息维护': '便民信息维护',
      '便民菜单维护': '便民菜单维护',
      '服务类型': '服务类型',
      '物品类型': '物品类型',
      '调拨审批': '调拨审批',
      '采购审批': '采购审批',
      '领用审批': '领用审批',
      '服务管理': '服务管理',
      '客户催单': '客户催单',
      '服务评价': '服务评价',
      '费用大类': '费用大类',
      '费用标准': '费用标准',
      '手机商城菜单': '手机商城菜单',
      '巡检明细': '巡检明细',
      '提现记录': '提现记录',
      '服务支付': '服务支付',
      '服务已办': '服务已办',
      '提现审核': '提现审核',
      '服务工单池': '服务工单池',
      '订单费用': '订单费用',
      '账户提现': '账户提现',
      '服务待办': '服务待办',
      '开户行管理': '开户行管理',
      '业主账户': '业主账户',
      '提现付款': '提现付款',
      '店铺类型': '店铺类型',
      '经营范围': '经营范围',
      '设置保证金': '设置保证金',
      '上架服务': '上架服务',
      '保证金明细': '保证金明细',
      '上架商品': '上架商品',
      '资产盘点': '资产盘点',
      '进货退货': '进货退货',
      '进货单': '进货单',
      '出库单': '出库单',
      '入库单': '入库单',
      '仓库调拨': '仓库调拨',
      '库存查询': '库存查询',
      '库存警告': '库存警告',
      '仓库管理': '仓库管理',
      '进货统计': '进货统计',
      '支付配置': '支付配置',
      '销售排行': '销售排行',
      '进货明细': '进货明细',
      '销售明细': '销售明细',
      '押金报表': '押金报表',
      '销售成本表': '销售成本表',
      '销售成本明细': '销售成本明细',
      '商品导入': '商品导入',
      '商品标签': '商品标签',
      '首页菜单': '首页菜单',
      '首页通知': '首页通知',
      '首页广告': '首页广告',
      '打标商品': '打标商品',
      '初始化小区': '初始化小区',
      '返省上报': '返省上报',
      '疫情设置': '疫情设置',
      '疫情上报': '疫情上报',
      '欠费分析': '欠费分析',
      '流程实例': '流程实例',
      '我的流程': '我的流程',
      '小区配置': '小区配置',
      '工作办理': '工作办理',
      'OA流程': 'OA流程',
      '业务轨迹': '业务轨迹',
      '收据模板': '收据模板',
      '取消费用': '取消费用',
      '产权登记': '产权登记',
      '设备类型': '设备类型',
      '视频监控': '视频监控',
      '岗亭管理': '岗亭管理',
      '车位申请': '车位申请',
      '报表组': '报表组',
      '报表组件': '报表组件',
      '报修报表': '报修报表',
      '报表信息': '报表信息',
      '购买记录': '购买记录',
      '制作优惠券': '制作优惠券',
      '优惠劵管理': '优惠劵管理',
      '店铺变更': '店铺变更',
      '变更记录': '变更记录',
      '店铺配置': '店铺配置',
      '赠送记录': '赠送记录',
      '菜单目录': '菜单目录',
      '营业报表': '营业报表',
      '周边商家': '周边商家',
      '物业公司': '物业公司',
      '结构图': '结构图',
      '巡检项目': '巡检项目',
      '车位结构图': '车位结构图',
      '巡检报表': '巡检报表',
      '供应链': '供应链',
      '集采中心': '集采中心',
      '集采订单': '集采订单',
      '商品定价': '商品定价',
      '字典': '字典',
      '角色权限': '角色权限',
      '运营员工': '运营员工',
      '业主反馈': '业主反馈',
      '系统配置': '系统配置',
      '数据权限': '数据权限',
      '员工考勤': '员工考勤',
      '盘点管理': '盘点管理',
      '场地管理': '场地管理',
      '场地预约订单': '场地预约订单',
      '场地预约': '场地预约',
      '下载中心': '下载中心',
      '营销配置': '营销配置',
      '营销方式': '营销方式',
      '营销规则': '营销规则',
      '营销记录': '营销记录',
      '营销黑名单': '营销黑名单',
      '排班设置': '排班设置',
      '排班表': '排班表',
      '班次设置': '班次设置',
      '检查项': '检查项',
      '保养标准': '保养标准',
      '场地核销': '场地核销',
      '保养计划': '保养计划',
      '保养明细': '保养明细',
      '保养任务': '保养任务',
      '保养设备': '保养设备',
      '供应商类型': '供应商类型',
      '巡检报告': '巡检报告',
      '优惠券订单': '优惠券订单',
      '优惠券': '优惠券',
      '优惠券市场': '优惠券市场',
      '业主优惠券': '业主优惠券',
      '优惠券使用': '优惠券使用',
      '赠送规则': '赠送规则',
      '核销优惠券': '核销优惠券',
      '订单核销': '订单核销',
      '积分标准': '积分标准',
      '积分赠送': '积分赠送',
      '小区积分': '小区积分',
      '积分规则': '积分规则',
      '核销积分': '核销积分',
      '积分设置': '积分设置',
      '拼团商品': '拼团商品',
      '拼团订单': '拼团订单',
      '拼团退单': '拼团退单',
      '秒杀商品': '秒杀商品',
      '注册协议': '注册协议',
      '放行类型': '放行类型',
      '物品放行': '物品放行',
      '访客审核': '访客审核',
      '配置项': '配置项',
      '云打印机': '云打印机',
      '云打印规则': '云打印规则',
      '考勤人员': '考勤人员',
      '小区公示': '小区公示',
      '数据统计': '数据统计',
      '导入日志': '导入日志',
      '业主投票': '业主投票',
      '操作日志': '操作日志',
      '调用三方': '调用三方',
      '审批配置': '审批配置',
      '支付二维码': '支付二维码',
      '房屋费用明细': '房屋费用明细',
      '充电桩订单': '充电桩订单',
      '催缴登记': '催缴登记',
      '业主': '业主',
      '道闸': '道闸',
      '发票': '发票',
      '发票抬头': '发票抬头',
      '运营分析': '运营分析',
      '小区费用汇总': '小区费用汇总',
      '工作单类型': '工作单类型',
      '起工作单': '起工作单',
      '员工巡楼': '员工巡楼',
      '办工作单': '办工作单',
      '抄送我的': '抄送我的',
      '临时车缴费': '临时车缴费',
      '投诉类型': '投诉类型',
      '小区金币': '小区金币',
      '监控': '监控',
      '充电桩': '充电桩',
      '用户积分': '用户积分',
      '积分交易': '积分交易',
      '工作单扣款': '工作单扣款',
      '小区房屋': '小区房屋',
      '小区业主': '小区业主',
      '小区费用项': '小区费用项',
      '小区车辆': '小区车辆',
      '小区报修': '小区报修',
      '房屋费用': '房屋费用',
      '小区巡检计划': '小区巡检计划',
      '物业用户': '物业用户',
      '小区投诉': '小区投诉',
      '缴费记录': '缴费记录',
      '小区工作单': '小区工作单',
      '小区欠费': '小区欠费',
      '地区': '地区',
      '物业员工': '物业员工',
      '小区公众号': '小区公众号',
      '小区小程序': '小区小程序',
      '小区支付': '小区支付',
      '充电订单': '充电订单',
      '小区门禁': '小区门禁',
      '水电充值': '水电充值',
      '门禁出入': '门禁出入',
      '车辆出入': '车辆出入',
      '水电表': '水电表',
      '道闸相机': '道闸相机',
      '员工小区': '员工小区',
      '公摊抄表': '公摊抄表',
      '商铺收费': '商铺收费',
      '物联网': '物联网',
      '商城': '商城',
      '常用菜单': '常用菜单',
      '搜索': '搜索',
      '查询我的小区': '查询我的小区',
      '费用套餐': '费用套餐',
      '临时缴费': '临时缴费',
      '按量缴费': '按量缴费',
      '创建费用': '创建费用 ',
      '装修审核': '装修审核',
      '房屋产权登记审批权限': '房屋产权登记审批权限',
      '删除房屋': '删除房屋',
      '添加房屋': '添加房屋',
      '修改房屋': '修改房屋',
      '退房': '退房',
      '交房': '交房',
      '删除业主': '删除业主',
      '添加业主': '添加业主',
      '修改业主': '修改业主',
      '绑定业主': '绑定业主',
      '预存' : '预存',
      '撤回预存': '撤回预存',
      '场地统计': '场地统计',
      '缴费': '缴费',
      '费用变更': '费用变更',
      '业主脱敏': '业主脱敏',
      '暂停费用': '暂停费用',
      '修改费用项': '修改费用项',
      '添加费用项': '添加费用项',
      '删除费用项': '删除费用项',
      '账单催缴': '账单催缴',
      '公摊公式': '公摊公式',
      '空置房验房': '空置房验房',
      '空置房审核': '空置房审核',
      '公摊审核': '公摊审核',
      '工作单池': '工作单池',
      '智慧考勤': '智慧考勤',
      '查看流程工单': '查看流程工单',
      '流程办理': '流程办理',
      '工单类型': '工单类型',
      '修改停车场': '修改停车场',
      '添加停车场': '添加停车场',
      '删除停车场': '删除停车场',
      '控制台': '控制台',
      '修改车辆': '修改车辆',
      '添加车辆': '添加车辆',
      '删除车辆': '删除车辆',
      '释放车位': '释放车位',
      '物业费': '物业费',
      '停车费': '停车费',
      '我的报表': '我的报表',
      '楼栋信息': '楼栋信息',
      '单元信息': '单元信息',
      '业主详情': '业主详情',
      '车位出租': '车位出租',
      '车位出售': '车位出售',
      '查询小区': '查询小区',
      '编码映射': '编码映射',
      '服务绑定': '服务绑定',
      '开发服务': '开发服务',
      '公告详情': '公告详情',
      '查看文件权限': '查看文件权限',
      '上传文件权限': '上传文件权限',
      '添加访客': '添加访客',
      '报修派单': '报修派单',
      '审核人员': '审核人员',
      '电话投诉': '电话投诉',
      '投诉已办': '投诉已办',
      '设备数据同步': '设备数据同步',
      '停车费用': '停车费用',
      '流程设置': '流程设置',
      '公众号菜单': '公众号菜单',
      '报修师傅': '报修师傅',
      '报修工单详情': '报修工单详情',
      '微信模板': '微信模板',
      'vvv': 'vvv',
      '我爱学习': '我爱学习',
      '权限测试': '权限测试',
      '欠费缴费': '欠费缴费',
      '属性值': '属性值',
      '添加楼栋': '添加楼栋',
      '修改单元': '修改单元',
      '删除楼栋': '删除楼栋',
      '修改楼栋': '修改楼栋',
      '删除单元': '删除单元',
      '添加单元': '添加单元',
      '预存费用': '预存费用',
      '合同类型规格': '合同类型规格',
      '合同审核': '合同审核',
      '托收信息': '托收信息',
      '托收明细': '托收明细',
      '租赁详情': '租赁详情',
      '商品分类': '商品分类',
      '费用分项表': '费用分项表',
      '楼栋费用表': '楼栋费用表',
      '费用到期提醒': '费用到期提醒',
      '拼团设置': '拼团设置',
      '拼团产品': '拼团产品',
      '拼团列表': '拼团列表',
      '拼团批次': '拼团批次',
      '推荐商品': '推荐商品',
      '商品订单': '商品订单',
      '商品订单详情': '商品订单详情',
      '费用项折扣': '费用项折扣',
      '微信缴费通知': '微信缴费通知',
      '物业管理员': '物业管理员',
      '空置房验房通知': '空置房验房通知',
      '空置房审核通知': '空置房审核通知',
      '报修登记通知': '报修登记通知',
      '临时车收费标准': '临时车收费标准',
      '删除报修记录': '删除报修记录',
      '修改报修记录': '修改报修记录',
      '报修抢单': '报修抢单',
      '问卷信息': '问卷信息',
      '问卷答题': '问卷答题',
      '员工考核': '员工考核',
      '我的问卷': '我的问卷',
      '最美员工': '最美员工',
      '房屋装修验收通知': '房屋装修验收通知',
      '装修记录': '装修记录',
      '子母车辆': '子母车辆',
      '装修详情': '装修详情',
      '商品目录': '商品目录',
      '专区商品': '专区商品',
      '查看所有采购申请': '查看所有采购申请',
      '查看集团仓库权限': '查看集团仓库权限',
      '查看所有报修已办权限': '查看所有报修已办权限',
      '查看所有物品领用': '查看所有物品领用',
      '入驻小区审核': '入驻小区审核',
      '查看所有集团物品信息': '查看所有集团物品信息',
      '查看所有报修待办': '查看所有报修待办',
      '查看所有调拨记录': '查看所有调拨记录',
      '出入库操作': '出入库操作',
      '物品供应商': '物品供应商',
      '合同费用': '合同费用',
      '物品使用记录': '物品使用记录',
      '金币设置': '金币设置',
      '购买金币': '购买金币',
      '商品入库': '商品入库',
      '会员账户': '会员账户',
      '订单详情': '订单详情',
      '查看所有出入库明细': '查看所有出入库明细',
      '查看所有组织架构信息': '查看所有组织架构信息',
      '家政服务': '家政服务',
      '家政物品信息': '家政物品信息',
      '家政服务评价': '家政服务评价',
      '费用类型': '费用类型',
      '商城菜单': '商城菜单',
      '家政支付': '家政支付',
      '家政已办': '家政已办',
      '家政待办': '家政待办',
      '家政工单池': '家政工单池',
      '积分商品': '积分商品',
      '查看所有人物品': '查看所有人物品',
      '紧急采购': '紧急采购',
      '短信配置': '短信配置',
      '出入库统计': '出入库统计',
      '销售统计': '销售统计',
      '首页推荐': '首页推荐',
      '华宁物业报表': '华宁物业报表',
      '验房记录': '验房记录',
      '验房记录详情': '验房记录详情',
      '流程': '流程',
      '物品信息(全)': '物品信息(全)',
      '物品使用记录(全)': '物品使用记录(全)',
      '项目管理': '项目管理',
      '大厦楼栋': '大厦楼栋',
      '问候语设置': '问候语设置',
      '修改仓库权限': '修改仓库权限',
      '产权登记详情': '产权登记详情',
      '修改菜单组': '修改菜单组',
      '查询服务权限': '查询服务权限',
      '删除菜单组': '删除菜单组',
      '查询菜单列表': '查询菜单列表',
      '新增服务提供': '新增服务提供',
      '保存报表组件': '保存报表组件',
      '删除编码映射': '删除编码映射',
      '修改手机菜单权限': '修改手机菜单权限',
      '修改服务提供': '修改服务提供',
      '删除报表组件': '删除报表组件',
      '修改菜单维护': '修改菜单维护',
      '查询菜单组': '查询菜单组',
      '新增编码映射': '新增编码映射',
      '查询服务注册': '查询服务注册',
      '缓存查询': '缓存查询',
      '删除报表组': '删除报表组',
      '查询服务实现': '查询服务实现',
      '修改报表组件': '修改报表组件',
      '添加服务注册': '添加服务注册',
      '删除服务实现': '删除服务实现',
      '保存报表信息': '保存报表信息',
      '保存手机菜单': '保存手机菜单',
      '删除服务提供': '删除服务提供',
      '查询编码映射': '查询编码映射',
      '修改服务': '修改服务',
      '修改编码映射': '修改编码映射',
      '修改服务实现': '修改服务实现',
      '新增服务实现': '新增服务实现',
      '保存报表组': '保存报表组',
      '删除服务注册': '删除服务注册',
      '删除服务': '删除服务',
      '删除菜单权限': '删除菜单权限',
      '新增菜单组': '新增菜单组',
      '新增菜单权限': '新增菜单权限',
      '修改报表信息': '修改报表信息',
      '删除手机菜单权限': '删除手机菜单权限',
      '查询服务提供': '查询服务提供',
      '添加服务': '添加服务',
      '修改报表组': '修改报表组',
      '删除报表信息': '删除报表信息',
      '删除仓库权限': '删除仓库权限',
      '调拨入库': '调拨入库',
      '删除巡检任务': '删除巡检任务',
      '取消采购': '取消采购',
      '预约车审核权限': '预约车审核权限',
      '测试菜单': '测试菜单',
      '供应链配置': '供应链配置',
      '供应链供应商分类': '供应链供应商分类',
      '门禁设备': '门禁设备',
      '考勤机': '考勤机',
      '车辆道闸': '车辆道闸',
      '监控设备': '监控设备',
      '服务记录': '服务记录',
      '修改物品信息': '修改物品信息',
      '添加物品信息': '添加物品信息',
      '删除物品信息': '删除物品信息',
      '导入物品信息': '导入物品信息',
      '查看不对外仓库权限': '查看不对外仓库权限',
      '修改角色权限': '修改角色权限',
      '关联员工权限': '关联员工权限',
      '删除关联员工信息': '删除关联员工信息',
      '删除员工信息': '删除员工信息',
      '删除角色权限': '删除角色权限',
      '删除组织信息权限': '删除组织信息权限',
      '修改组织信息权限': '修改组织信息权限',
      '删除关联员工权限': '删除关联员工权限',
      '功能授权权限': '功能授权权限',
      '员工关联权限': '员工关联权限',
      '小区授权权限': '小区授权权限',
      '添加组织信息权限': '添加组织信息权限',
      '更新员工信息': '更新员工信息',
      '添加员工信息': '添加员工信息',
      '添加角色权限': '添加角色权限',
      '删除岗亭': '删除岗亭',
      '修改岗亭': '修改岗亭',
      '共享岗亭': '共享岗亭',
      '停车券': '停车券',
      '小区商家': '小区商家',
      '优惠券购买订单': '优惠券购买订单',
      '车辆停车劵': '车辆停车劵',
      '停车劵核销': '停车劵核销',
      '修改员工': '修改员工',
      '删除员工': '删除员工',
      '添加员工': '添加员工',
      '预约核销': '预约核销',
      '巡检统计推送管理员': '巡检统计推送管理员',
      '优惠券购买记录': '优惠券购买记录',
      '优惠券规则': '优惠券规则',
      '商圈菜单': '商圈菜单',
      '物品规格修改权限': '物品规格修改权限',
      '物品供应商删除权限': '物品供应商删除权限',
      '预约目录': '预约目录',
      '物品供应商修改权限': '物品供应商修改权限',
      '物品类型删除权限': '物品类型删除权限',
      '物品规格删除权限': '物品规格删除权限',
      '物品类型修改权限': '物品类型修改权限',
      '修改二级分类': '修改二级分类',
      '删除二级分类': '删除二级分类',
      '业主入驻': '业主入驻',
      '打印规则': '打印规则',
      '智能水电表': '智能水电表',
      '充电规则': '充电规则',
      '续租车位': '续租车位',
      '充电月卡': '充电月卡',
      '已删除数据': '已删除数据',
      '添加databus': '添加databus',
      '添加业务轨迹': '添加业务轨迹',
      '修改databus': '修改databus',
      '启动定时任务': '启动定时任务',
      '添加属性': '添加属性',
      '删除属性值': '删除属性值',
      '添加菜单目录': '添加菜单目录',
      '删除应用': '删除应用',
      '添加配置项': '添加配置项',
      '修改注册协议': '修改注册协议',
      '删除业务轨迹': '删除业务轨迹',
      '删除属性': '删除属性',
      '停止定时任务': '停止定时任务',
      '删除databus': '删除databus',
      '添加属性值': '添加属性值',
      '测试定时任务': '测试定时任务',
      '添加应用': '添加应用',
      '修改应用': '修改应用',
      '修改系统配置': '修改系统配置',
      '删除字典': '删除字典',
      '删除定时任务': '删除定时任务',
      '修改定时任务': '修改定时任务',
      '修改属性': '修改属性',
      '修改字典': '修改字典',
      '添加字典': '添加字典',
      '修改业务轨迹': '修改业务轨迹',
      '物业费台账': '物业费台账',
      '停车费台账': '停车费台账',
      '查看所有使用记录权限': '查看所有使用记录权限',
      '修改商城菜单': '修改商城菜单',
      '工作单流转': '工作单流转',
      '导入日志详情': '导入日志详情',
      '店铺详情': '店铺详情',
      '商城运营':'商城运营',
      '数据':'数据'
    }
  },
  'zh-TW': {
    menu: {
      '首页': '首頁',
      '小区': '小區',
      '物业': '物業',
      '用户': '用戶',
      'OA': 'OA',
      '财务': '財務',
      'IOT': 'IOT',
      '市场': '市場',
      '设置': '設置',
      '组织': '組織',
      '物业管理': '物業管理',
      '房产': '房產',
      '办公': '辦公',
      '采购': '採購',
      'DEMO管理': 'DEMO管理',
      '服务': '服務',
      '配置': '配置',
      '缓存': '緩存',
      '菜单': '菜單',
      '任务': '任務',
      '系统': '系統',
      '报修': '報修',
      '费用': '費用',
      '设备': '設備',
      '停车': '停車',
      '巡检': '巡檢',
      '订单': '訂單',
      '运营': '運營',
      '标签': '標籤',
      '文档': '文檔',
      '属性': '屬性',
      '租赁': '租賃',
      '合同': '合約',
      '营销': '營銷',
      '报表': '報表',
      '日志': '日誌',
      '物业手机版': '物業手機版',
      '会员': '會員',
      '统计': '統計',
      '手机': '手機',
      '店铺': '店鋪',
      '集采': '集採',
      '供应商': '供應商',
      '优惠': '優惠',
      '活动': '活動',
      '手机报表': '手機報表',
      '手机停车': '手機停車',
      '手机工单': '手機工單',
      '手机核销': '手機核銷',
      '台账': '台帳',
      '巡楼': '巡樓',
      '资产': '資產',
      '工单': '工單',
      '员工信息': '員工資訊',
      '房屋管理': '房屋管理',
      '我的小区': '我的小區',
      '发布公告': '發布公告',
      '业主信息': '業主資訊',
      '业主成员': '業主成員',
      '车位信息': '車位資訊',
      '采购申请': '採購申請',
      'DEMO用例': 'DEMO用例',
      '小区信息': '小區資訊',
      '应用信息': '應用資訊',
      '服务信息': '服務資訊',
      '服务实现': '服務實現',
      '配置中心': '配置中心',
      '服务注册': '服務註冊',
      '访客登记': '訪客登記',
      '刷新缓存': '刷新緩存',
      '菜单组': '菜單組',
      '菜单维护': '菜單維護',
      '服务提供': '服務提供',
      '定时任务': '定時任務',
      '审核小区': '審核小區',
      '商户审核': '商戶審核',
      '资产导入导出': '資產匯入匯出',
      '组织信息': '組織資訊',
      '报修待办': '報修待辦',
      '报修已办': '報修已辦',
      '物品信息': '物品資訊',
      '物品领用': '物品領用',
      '投诉建议': '投訴建議',
      '设备台账': '設備台帳',
      '物联网同步': '物聯網同步',
      '开门记录': '開門記錄',
      '业主认证': '業主認證',
      '信息发布': '資訊發布',
      '停车场管理': '停車場管理',
      '在场车辆': '在場車輛',
      '进场记录': '進場記錄',
      '剩余车位': '剩餘車位',
      '费用项设置': '費用項設置',
      '车辆收费': '車輛收費',
      '房屋收费': '房屋收費',
      '修改密码': '修改密碼',
      '巡检点': '巡檢點',
      '巡检路线': '巡檢路線',
      '巡检计划': '巡檢計劃',
      '商户信息': '商戶資訊',
      '审核入驻小区': '審核入駐小區',
      '巡检任务': '巡檢任務',
      '受理单': '受理單',
      '发布需求': '發布需求',
      '旧货甩卖': '舊貨甩賣',
      '退费审核': '退費審核',
      '小程序配置': '小程式配置',
      '欠费催缴': '欠費催繳',
      '设备位置': '設備位置',
      '流程管理': '流程管理',
      '公众号': '公眾號',
      '报修设置': '報修設置',
      '电话报修': '電話報修',
      '工单池': '工單池',
      '小区大屏': '小區大屏',
      '费用导入': '費用匯入',
      '租赁配置': '租賃配置',
      '房源信息': '房源資訊',
      '出租审核': '出租審核',
      '业主车辆': '業主車輛',
      '水电抄表': '水電抄表',
      '房源': '房源',
      '楼栋公摊': '樓棟公攤',
      '租赁预约': '租賃預約',
      '合同信息': '合約資訊',
      '合同查询': '合約查詢',
      '合同类型': '合約類型',
      '登录日志': '登入日誌',
      '打印配置': '列印配置',
      '补打收据': '補打收據',
      '出租历史': '出租歷史',
      '信息大类': '資訊大類',
      '文档信息': '文檔資訊',
      '业务受理': '業務受理',
      '费用汇总表': '費用匯總表',
      '费用明细表': '費用明細表',
      '欠费明细表': '欠費明細表',
      '缴费明细表': '繳費明細表',
      '商城订单': '商城訂單',
      '交互日志': '交互日誌',
      '退货订单': '退貨訂單',
      '折扣设置': '折扣設置',
      'Databus': 'Databus',
      '员工认证': '員工認證',
      '优惠申请': '優惠申請',
      '商户管理员': '商戶管理員',
      '商铺管理': '商鋪管理',
      '考勤班组': '考勤班組',
      '收银台': '收銀台',
      '投诉待办': '投訴待辦',
      '房产查询': '房產查詢',
      '空置房': '空置房',
      '维修工单': '維修工單',
      '公告': '公告',
      '维修待办': '維修待辦',
      '巡检打卡': '巡檢打卡',
      '房屋装修': '房屋裝修',
      '报修汇总表': '報修匯總表',
      '今日考勤': '今日考勤',
      '月考勤': '月考勤',
      '考勤记录': '考勤記錄',
      '问卷调研': '問卷調研',
      '问卷题目': '問卷題目',
      '店铺小区': '店鋪小區',
      '收款账户': '收款帳戶',
      '财务明细': '財務明細',
      '保证金': '保證金',
      '商品管理': '商品管理',
      '订单信息': '訂單資訊',
      '店铺信息': '店鋪資訊',
      '商品规格': '商品規格',
      '商品分组': '商品分組',
      '合同变更': '合約變更',
      '到期合同': '到期合約',
      '起草合同': '起草合約',
      '报修回访': '報修回訪',
      '强制回单': '強制回單',
      '仓库信息': '倉庫資訊',
      '调拨申请': '調撥申請',
      '我的物品': '我的物品',
      '代客报修': '代客報修',
      '自助缴费': '自助繳費',
      '小区店铺': '小區店鋪',
      '会员信息': '會員資訊',
      '合同甲方': '合約甲方',
      '出入库明细': '出入庫明細',
      '合同收费': '合約收費',
      '转赠记录': '轉贈記錄',
      '使用记录': '使用記錄',
      '会员等级': '會員等級',
      '未收费房屋': '未收費房屋',
      '金币购买记录': '金幣購買記錄',
      '调拨明细': '調撥明細',
      '物品规格': '物品規格',
      '商品评论': '商品評論',
      '店铺访问': '店鋪訪問',
      '退货地址': '退貨地址',
      '发布广告': '發布廣告',
      '物品调拨': '物品調撥',
      '便民信息维护': '便民資訊維護',
      '便民菜单维护': '便民菜單維護',
      '服务类型': '服務類型',
      '物品类型': '物品類型',
      '调拨审批': '調撥審批',
      '采购审批': '採購審批',
      '领用审批': '領用審批',
      '服务管理': '服務管理',
      '客户催单': '客戶催單',
      '服务评价': '服務評價',
      '费用大类': '費用大類',
      '费用标准': '費用標準',
      '手机商城菜单': '手機商城菜單',
      '巡检明细': '巡檢明細',
      '提现记录': '提現記錄',
      '服务支付': '服務支付',
      '服务已办': '服務已辦',
      '提现审核': '提現審核',
      '服务工单池': '服務工單池',
      '订单费用': '訂單費用',
      '账户提现': '帳戶提現',
      '服务待办': '服務待辦',
      '开户行管理': '開戶行管理',
      '业主账户': '業主帳戶',
      '提现付款': '提現付款',
      '店铺类型': '店鋪類型',
      '经营范围': '經營範圍',
      '设置保证金': '設置保證金',
      '上架服务': '上架服務',
      '保证金明细': '保證金明細',
      '上架商品': '上架商品',
      '资产盘点': '資產盤點',
      '进货退货': '進貨退貨',
      '进货单': '進貨單',
      '出库单': '出庫單',
      '入库单': '入庫單',
      '仓库调拨': '倉庫調撥',
      '库存查询': '庫存查詢',
      '库存警告': '庫存警告',
      '仓库管理': '倉庫管理',
      '进货统计': '進貨統計',
      '支付配置': '支付配置',
      '销售排行': '銷售排行',
      '进货明细': '進貨明細',
      '销售明细': '銷售明細',
      '押金报表': '押金報表',
      '销售成本表': '銷售成本表',
      '销售成本明细': '銷售成本明細',
      '商品导入': '商品匯入',
      '商品标签': '商品標籤',
      '首页菜单': '首頁菜單',
      '首页通知': '首頁通知',
      '首页广告': '首頁廣告',
      '打标商品': '打標商品',
      '初始化小区': '初始化小區',
      '返省上报': '返省上報',
      '疫情设置': '疫情設置',
      '疫情上报': '疫情上報',
      '欠费分析': '欠費分析',
      '流程实例': '流程實例',
      '我的流程': '我的流程',
      '小区配置': '小區配置',
      '工作办理': '工作辦理',
      'OA流程': 'OA流程',
      '业务轨迹': '業務軌跡',
      '收据模板': '收據模板',
      '取消费用': '取消費用',
      '产权登记': '產權登記',
      '设备类型': '設備類型',
      '视频监控': '視頻監控',
      '岗亭管理': '崗亭管理',
      '车位申请': '車位申請',
      '报表组': '報表組',
      '报表组件': '報表元件',
      '报修报表': '報修報表',
      '报表信息': '報表資訊',
      '购买记录': '購買記錄',
      '制作优惠券': '製作優惠券',
      '优惠劵管理': '優惠劵管理',
      '店铺变更': '店鋪變更',
      '变更记录': '變更記錄',
      '店铺配置': '店鋪配置',
      '赠送记录': '贈送記錄',
      '菜单目录': '菜單目錄',
      '营业报表': '營業報表',
      '周边商家': '周邊商家',
      '物业公司': '物業公司',
      '结构图': '結構圖',
      '巡检项目': '巡檢項目',
      '车位结构图': '車位結構圖',
      '巡检报表': '巡檢報表',
      '供应链': '供應鏈',
      '集采中心': '集採中心',
      '集采订单': '集採訂單',
      '商品定价': '商品定價',
      '字典': '字典',
      '角色权限': '角色權限',
      '运营员工': '運營員工',
      '业主反馈': '業主反饋',
      '系统配置': '系統配置',
      '数据权限': '資料權限',
      '员工考勤': '員工考勤',
      '盘点管理': '盤點管理',
      '场地管理': '場地管理',
      '场地预约订单': '場地預約訂單',
      '场地预约': '場地預約',
      '下载中心': '下載中心',
      '营销配置': '營銷配置',
      '营销方式': '營銷方式',
      '营销规则': '營銷規則',
      '营销记录': '營銷記錄',
      '营销黑名单': '營銷黑名單',
      '排班设置': '排班設置',
      '排班表': '排班表',
      '班次设置': '班次設置',
      '检查项': '檢查項',
      '保养标准': '保養標準',
      '场地核销': '場地核銷',
      '保养计划': '保養計劃',
      '保养明细': '保養明細',
      '保养任务': '保養任務',
      '保养设备': '保養設備',
      '供应商类型': '供應商類型',
      '巡检报告': '巡檢報告',
      '优惠券订单': '優惠券訂單',
      '优惠券': '優惠券',
      '优惠券市场': '優惠券市場',
      '业主优惠券': '業主優惠券',
      '优惠券使用': '優惠券使用',
      '赠送规则': '贈送規則',
      '核销优惠券': '核銷優惠券',
      '订单核销': '訂單核銷',
      '积分标准': '積分標準',
      '积分赠送': '積分贈送',
      '小区积分': '小區積分',
      '积分规则': '積分規則',
      '核销积分': '核銷積分',
      '积分设置': '積分設置',
      '拼团商品': '拼團商品',
      '拼团订单': '拼團訂單',
      '拼团退单': '拼團退單',
      '秒杀商品': '秒殺商品',
      '注册协议': '註冊協議',
      '放行类型': '放行類型',
      '物品放行': '物品放行',
      '访客审核': '訪客審核',
      '配置项': '配置項',
      '云打印机': '雲打印機',
      '云打印规则': '雲列印規則',
      '考勤人员': '考勤人員',
      '小区公示': '小區公示',
      '数据统计': '資料統計',
      '导入日志': '匯入日誌',
      '业主投票': '業主投票',
      '操作日志': '操作日誌',
      '调用三方': '呼叫三方',
      '审批配置': '審批配置',
      '支付二维码': '支付二維碼',
      '房屋费用明细': '房屋費用明細',
      '充电桩订单': '充電樁訂單',
      '催缴登记': '催繳登記',
      '业主': '業主',
      '道闸': '道閘',
      '发票': '發票',
      '发票抬头': '發票抬頭',
      '运营分析': '運營分析',
      '小区费用汇总': '小區費用匯總',
      '工作单类型': '工作單類型',
      '起工作单': '起工作單',
      '员工巡楼': '員工巡樓',
      '办工作单': '辦工作單',
      '抄送我的': '抄送我的',
      '临时车缴费': '臨時車繳費',
      '投诉类型': '投訴類型',
      '小区金币': '小區金幣',
      '监控': '監控',
      '充电桩': '充電樁',
      '用户积分': '用戶積分',
      '积分交易': '積分交易',
      '工作单扣款': '工作單扣款',
      '小区房屋': '小區房屋',
      '小区业主': '小區業主',
      '小区费用项': '小區費用項',
      '小区车辆': '小區車輛',
      '小区报修': '小區報修',
      '房屋费用': '房屋費用',
      '小区巡检计划': '小區巡檢計劃',
      '物业用户': '物業用戶',
      '小区投诉': '小區投訴',
      '缴费记录': '繳費記錄',
      '小区工作单': '小區工作單',
      '小区欠费': '小區欠費',
      '地区': '地區',
      '物业员工': '物業員工',
      '小区公众号': '小區公眾號',
      '小区小程序': '小區小程式',
      '小区支付': '小區支付',
      '充电订单': '充電訂單',
      '小区门禁': '小區門禁',
      '水电充值': '水電充值',
      '门禁出入': '門禁出入',
      '车辆出入': '車輛出入',
      '水电表': '水電表',
      '道闸相机': '道閘相機',
      '员工小区': '員工小區',
      '公摊抄表': '公攤抄表',
      '商铺收费': '商鋪收費',
      '物联网': '物聯網',
      '商城': '商城',
      '常用菜单': '常用菜單',
      '搜索': '搜尋',
      '查询我的小区': '查詢我的小區',
      '费用套餐': '費用套餐',
      '临时缴费': '臨時繳費',
      '按量缴费': '按量繳費',
      '创建费用': '創建費用',
      '装修审核': '裝修審核',
      '房屋产权登记审批权限': '房屋產權登記審批權限',
      '删除房屋': '刪除房屋',
      '添加房屋': '添加房屋',
      '修改房屋': '修改房屋',
      '退房': '退房',
      '交房': '交房',
      '删除业主': '刪除業主',
      '添加业主': '添加業主',
      '修改业主': '修改業主',
      '绑定业主': '綁定業主',
      '预存': '預存',
      '撤回预存': '撤回預存',
      '场地统计': '場地統計',
      '缴费': '繳費',
      '费用变更': '費用變更',
      '业主脱敏': '業主脫敏',
      '暂停费用': '暫停費用',
      '修改费用项': '修改費用項',
      '添加费用项': '添加費用項',
      '删除费用项': '刪除費用項',
      '账单催缴': '帳單催繳',
      '公摊公式': '公攤公式',
      '空置房验房': '空置房驗房',
      '空置房审核': '空置房審核',
      '公摊审核': '公攤審核',
      '工作单池': '工作單池',
      '智慧考勤': '智慧考勤',
      '查看流程工单': '查看流程工單',
      '流程办理': '流程辦理',
      '工单类型': '工單類型',
      '修改停车场': '修改停車場',
      '添加停车场': '添加停車場',
      '删除停车场': '刪除停車場',
      '控制台': '控制台',
      '修改车辆': '修改車輛',
      '添加车辆': '添加車輛',
      '删除车辆': '刪除車輛',
      '释放车位': '釋放車位',
      '物业费': '物業費',
      '停车费': '停車費',
      '我的报表': '我的報表',
      '楼栋信息': '樓棟資訊',
      '单元信息': '單元資訊',
      '业主详情': '業主詳情',
      '车位出租': '車位出租',
      '车位出售': '車位出售',
      '查询小区': '查詢小區',
      '编码映射': '編碼映射',
      '服务绑定': '服務綁定',
      '开发服务': '開發服務',
      '公告详情': '公告詳情',
      '查看文件权限': '查看檔案權限',
      '上传文件权限': '上傳檔案權限',
      '添加访客': '添加訪客',
      '报修派单': '報修派單',
      '审核人员': '審核人員',
      '电话投诉': '電話投訴',
      '投诉已办': '投訴已辦',
      '设备数据同步': '設備資料同步',
      '停车费用': '停車費用',
      '流程设置': '流程設置',
      '公众号菜单': '公眾號菜單',
      '报修师傅': '報修師傅',
      '报修工单详情': '報修工單詳情',
      '微信模板': '微信模板',
      '我爱学习': '我愛學習',
      '权限测试': '權限測試',
      '欠费缴费': '欠費繳費',
      '属性值': '屬性值',
      '添加楼栋': '添加樓棟',
      '修改单元': '修改單元',
      '删除楼栋': '刪除樓棟',
      '修改楼栋': '修改樓棟',
      '删除单元': '刪除單元',
      '添加单元': '添加單元',
      '预存费用': '預存費用',
      '合同类型规格': '合約類型規格',
      '合同审核': '合約審核',
      '托收信息': '托收資訊',
      '托收明细': '托收明細',
      '租赁详情': '租賃詳情',
      '商品分类': '商品分類',
      '费用分项表': '費用分項表',
      '楼栋费用表': '樓棟費用表',
      '费用到期提醒': '費用到期提醒',
      '拼团设置': '拼團設置',
      '拼团产品': '拼團產品',
      '拼团列表': '拼團列表',
      '拼团批次': '拼團批次',
      '推荐商品': '推薦商品',
      '商品订单': '商品訂單',
      '商品订单详情': '商品訂單詳情',
      '费用项折扣': '費用項折扣',
      '微信缴费通知': '微信繳費通知',
      '物业管理员': '物業管理員',
      '空置房验房通知': '空置房驗房通知',
      '空置房审核通知': '空置房審核通知',
      '报修登记通知': '報修登記通知',
      '临时车收费标准': '臨時車收費標準',
      '删除报修记录': '刪除報修記錄',
      '修改报修记录': '修改報修記錄',
      '报修抢单': '報修搶單',
      '问卷信息': '問卷資訊',
      '问卷答题': '問卷答題',
      '员工考核': '員工考核',
      '我的问卷': '我的問卷',
      '最美员工': '最美員工',
      '房屋装修验收通知': '房屋裝修驗收通知',
      '装修记录': '裝修記錄',
      '子母车辆': '子母車輛',
      '装修详情': '裝修詳情',
      '商品目录': '商品目錄',
      '专区商品': '專區商品',
      '查看所有采购申请': '查看所有採購申請',
      '查看集团仓库权限': '查看集團倉庫權限',
      '查看所有报修已办权限': '查看所有報修已辦權限',
      '查看所有物品领用': '查看所有物品領用',
      '入驻小区审核': '入駐小區審核',
      '查看所有集团物品信息': '查看所有集團物品資訊',
      '查看所有报修待办': '查看所有報修待辦',
      '查看所有调拨记录': '查看所有調撥記錄',
      '出入库操作': '出入庫操作',
      '物品供应商': '物品供應商',
      '合同费用': '合約費用',
      '物品使用记录': '物品使用記錄',
      '金币设置': '金幣設置',
      '购买金币': '購買金幣',
      '商品入库': '商品入庫',
      '会员账户': '會員帳戶',
      '订单详情': '訂單詳情',
      '查看所有出入库明细': '查看所有出入庫明細',
      '查看所有组织架构信息': '查看所有組織架構資訊',
      '家政服务': '家政服務',
      '家政物品信息': '家政物品資訊',
      '家政服务评价': '家政服務評價',
      '费用类型': '費用類型',
      '商城菜单': '商城菜單',
      '家政支付': '家政支付',
      '家政已办': '家政已辦',
      '家政待办': '家政待辦',
      '家政工单池': '家政工單池',
      '积分商品': '積分商品',
      '查看所有人物品': '查看所有人物品',
      '紧急采购': '緊急採購',
      '短信配置': '簡訊配置',
      '出入库统计': '出入庫統計',
      '销售统计': '銷售統計',
      '首页推荐': '首頁推薦',
      '华宁物业报表': '華寧物業報表',
      '验房记录': '驗房記錄',
      '验房记录详情': '驗房記錄詳情',
      '流程': '流程',
      '物品信息(全)': '物品資訊(全)',
      '物品使用记录(全)': '物品使用記錄(全)',
      '项目管理': '專案管理',
      '大厦楼栋': '大廈樓棟',
      '问候语设置': '問候語設置',
      '修改仓库权限': '修改倉庫權限',
      '产权登记详情': '產權登記詳情',
      '修改菜单组': '修改菜單組',
      '查询服务权限': '查詢服務權限',
      '删除菜单组': '刪除菜單組',
      '查询菜单列表': '查詢菜單列表',
      '新增服务提供': '新增服務提供',
      '保存报表组件': '保存報表元件',
      '删除编码映射': '刪除編碼映射',
      '修改手机菜单权限': '修改手機菜單權限',
      '修改服务提供': '修改服務提供',
      '删除报表组件': '刪除報表元件',
      '修改菜单维护': '修改菜單維護',
      '查询菜单组': '查詢菜單組',
      '新增编码映射': '新增編碼映射',
      '查询服务注册': '查詢服務註冊',
      '缓存查询': '緩存查詢',
      '删除报表组': '刪除報表組',
      '查询服务实现': '查詢服務實現',
      '修改报表组件': '修改報表元件',
      '添加服务注册': '添加服務註冊',
      '删除服务实现': '刪除服務實現',
      '保存报表信息': '保存報表資訊',
      '保存手机菜单': '保存手機菜單',
      '删除服务提供': '刪除服務提供',
      '查询编码映射': '查詢編碼映射',
      '修改服务': '修改服務',
      '修改编码映射': '修改編碼映射',
      '修改服务实现': '修改服務實現',
      '新增服务实现': '新增服務實現',
      '保存报表组': '保存報表組',
      '删除服务注册': '刪除服務註冊',
      '删除服务': '刪除服務',
      '删除菜单权限': '刪除菜單權限',
      '新增菜单组': '新增菜單組',
      '新增菜单权限': '新增菜單權限',
      '修改报表信息': '修改報表資訊',
      '删除手机菜单权限': '刪除手機菜單權限',
      '查询服务提供': '查詢服務提供',
      '添加服务': '添加服務',
      '修改报表组': '修改報表組',
      '删除报表信息': '刪除報表資訊',
      '删除仓库权限': '刪除倉庫權限',
      '调拨入库': '調撥入庫',
      '删除巡检任务': '刪除巡檢任務',
      '取消采购': '取消採購',
      '预约车审核权限': '預約車審核權限',
      '测试菜单': '測試菜單',
      '供应链配置': '供應鏈配置',
      '供应链供应商分类': '供應鏈供應商分類',
      '门禁设备': '門禁設備',
      '考勤机': '考勤機',
      '车辆道闸': '車輛道閘',
      '监控设备': '監控設備',
      '服务记录': '服務記錄',
      '修改物品信息': '修改物品資訊',
      '添加物品信息': '添加物品資訊',
      '删除物品信息': '刪除物品資訊',
      '导入物品信息': '匯入物品資訊',
      '查看不对外仓库权限': '查看不對外倉庫權限',
      '修改角色权限': '修改角色權限',
      '关联员工权限': '關聯員工權限',
      '删除关联员工信息': '刪除關聯員工資訊',
      '删除员工信息': '刪除員工資訊',
      '删除角色权限': '刪除角色權限',
      '删除组织信息权限': '刪除組織資訊權限',
      '修改组织信息权限': '修改組織資訊權限',
      '删除关联员工权限': '刪除關聯員工權限',
      '功能授权权限': '功能授權權限',
      '员工关联权限': '員工關聯權限',
      '小区授权权限': '小區授權權限',
      '添加组织信息权限': '添加組織資訊權限',
      '更新员工信息': '更新員工資訊',
      '添加员工信息': '添加員工資訊',
      '添加角色权限': '添加角色權限',
      '删除岗亭': '刪除崗亭',
      '修改岗亭': '修改崗亭',
      '共享岗亭': '共享崗亭',
      '停车券': '停車券',
      '小区商家': '小區商家',
      '优惠券购买订单': '優惠券購買訂單',
      '车辆停车劵': '車輛停車劵',
      '停车劵核销': '停車劵核銷',
      '修改员工': '修改員工',
      '删除员工': '刪除員工',
      '添加员工': '添加員工',
      '预约核销': '預約核銷',
      '巡检统计推送管理员': '巡檢統計推送管理員',
      '优惠券购买记录': '優惠券購買記錄',
      '优惠券规则': '優惠券規則',
      '商圈菜单': '商圈菜單',
      '物品规格修改权限': '物品規格修改權限',
      '物品供应商删除权限': '物品供應商刪除權限',
      '预约目录': '預約目錄',
      '物品供应商修改权限': '物品供應商修改權限',
      '物品类型删除权限': '物品類型刪除權限',
      '物品规格删除权限': '物品規格刪除權限',
      '物品类型修改权限': '物品類型修改權限',
      '修改二级分类': '修改二級分類',
      '删除二级分类': '刪除二級分類',
      '业主入驻': '業主入駐',
      '打印规则': '列印規則',
      '智能水电表': '智慧水電表',
      '充电规则': '充電規則',
      '续租车位': '續租車位',
      '充电月卡': '充電月卡',
      '已删除数据': '已刪除資料',
      '添加databus': '添加databus',
      '添加业务轨迹': '添加業務軌跡',
      '修改databus': '修改databus',
      '启动定时任务': '啟動定時任務',
      '添加属性': '添加屬性',
      '删除属性值': '刪除屬性值',
      '添加菜单目录': '添加菜單目錄',
      '删除应用': '刪除應用',
      '添加配置项': '添加配置項',
      '修改注册协议': '修改註冊協議',
      '删除业务轨迹': '刪除業務軌跡',
      '删除属性': '刪除屬性',
      '停止定时任务': '停止定時任務',
      '删除databus': '刪除databus',
      '添加属性值': '添加屬性值',
      '测试定时任务': '測試定時任務',
      '添加应用': '添加應用',
      '修改应用': '修改應用',
      '修改系统配置': '修改系統配置',
      '删除字典': '刪除字典',
      '删除定时任务': '刪除定時任務',
      '修改定时任务': '修改定時任務',
      '修改属性': '修改屬性',
      '修改字典': '修改字典',
      '添加字典': '添加字典',
      '修改业务轨迹': '修改業務軌跡',
      '物业费台账': '物業費台帳',
      '停车费台账': '停車費台帳',
      '查看所有使用记录权限': '查看所有使用記錄權限',
      '修改商城菜单': '修改商城菜單',
      '工作单流转': '工作單流轉',
      '导入日志详情': '匯入日誌詳情',
      '店铺详情': '店鋪詳情',
      '商城运营': '商城運營',
      '数据': '資料',
    }
  }
}